var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseDatePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 280,
    viewBox: "0 0 168 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1203_13346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79255 133.405C10.1188 137.719 15.056 139.571 15.056 139.571C15.056 139.571 16.2215 134.429 13.8953 130.115C11.569 125.8 6.63183 123.948 6.63183 123.948C6.63183 123.948 5.46629 129.091 7.79255 133.405Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39169 131.986C13.5915 134.513 15.2091 139.532 15.2091 139.532C15.2091 139.532 10.0172 140.454 5.81736 137.927C1.6175 135.4 0 130.381 0 130.381C0 130.381 5.19182 129.459 9.39169 131.986Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.554 6.72095H77.3494V7.09529H103.554V6.72095Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4407 7.00171H96.0664V10.4644H96.4407V7.00171Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0233 7.00171H84.6489V10.4644H85.0233V7.00171Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.843 24.6896H90.6387V25.0639H116.843V24.6896Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1253 21.3204H97.751V24.7831H98.1253V21.3204Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.543 21.3204H109.169V24.7831H109.543V21.3204Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.657 33.1124H125.453V33.4867H151.657V33.1124Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.94 29.7432H132.565V33.2059H132.94V29.7432Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.357 29.7432H143.983V33.2059H144.357V29.7432Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.036 119.961H122.832V120.335H149.036V119.961Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.319 116.591H129.945V120.054H130.319V116.591Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.737 116.591H141.362V120.054H141.737V116.591Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.302 59.8781H78.0979V60.2524H104.302V59.8781Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5848 56.509H85.2104V59.9717H85.5848V56.509Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0023 56.509H96.6279V59.9717H97.0023V56.509Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.538 104.987H86.3335V105.361H112.538V104.987Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8204 101.618H93.446V105.08H93.8204V101.618Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.238 101.618H104.864V105.08H105.238V101.618Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.464 91.3231H128.26V91.6975H154.464V91.3231Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.747 87.954H135.373V91.4167H135.747V87.954Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.165 87.954H146.791V91.4167H147.165V87.954Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7674 131.43H23.4475V131.111H67.4485V115.647H27.1734L25.2169 111.571L25.5044 111.433L27.374 115.328H67.7674V131.43Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3469 139.242C31.1959 139.242 32.6948 137.743 32.6948 135.894C32.6948 134.045 31.1959 132.546 29.3469 132.546C27.4979 132.546 25.999 134.045 25.999 135.894C25.999 137.743 27.4979 139.242 29.3469 139.242Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3474 139.242C64.1964 139.242 65.6953 137.743 65.6953 135.894C65.6953 134.045 64.1964 132.546 62.3474 132.546C60.4984 132.546 58.9995 134.045 58.9995 135.894C58.9995 137.743 60.4984 139.242 62.3474 139.242Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.247 66.863C102.392 66.863 103.32 65.9351 103.32 64.7905C103.32 63.6459 102.392 62.718 101.247 62.718C100.102 62.718 99.1746 63.6459 99.1746 64.7905C99.1746 65.9351 100.102 66.863 101.247 66.863Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5081 110.386H22.6923L11.9133 75.1531H83.6088L83.5436 75.3604L72.5081 110.386ZM22.9282 110.067H72.2743L83.1741 75.4719H12.3443L22.9282 110.067Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6196 108.552H24.8646L15.397 77.3053H78.3696L78.3123 77.4893L68.6196 108.552Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5019 72.0054L84.1936 71.9236L86.2976 63.9933H98.5367V64.3123H86.543L84.5019 72.0054Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0258 85.8345H15.3962V86.1533H80.0258V85.8345Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3248 97.5814H18.9902V97.9003H76.3248V97.5814Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9197 75.3124H47.6008V110.226H47.9197V75.3124Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1948 75.3025L59.906 110.216L60.2242 110.236L62.5131 75.3233L62.1948 75.3025Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3317 75.3021L33.0134 75.3228L35.2889 110.237L35.6072 110.216L33.3317 75.3021Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.707 139.444H0V139.818H167.707V139.444Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.445 11.5815C111.445 11.5815 114.181 19.3691 112.497 20.5672C110.813 21.7652 118.18 31.5496 118.18 31.5496L127.02 29.1534L122.179 20.9665C122.179 20.9665 121.547 12.7796 121.547 11.5815C121.547 10.3834 111.445 11.5815 111.445 11.5815Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.445 11.5815C111.445 11.5815 114.181 19.3691 112.497 20.5672C110.813 21.7652 118.18 31.5496 118.18 31.5496L127.02 29.1534L122.179 20.9665C122.179 20.9665 121.547 12.7796 121.547 11.5815C121.547 10.3834 111.445 11.5815 111.445 11.5815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.853 67.0929C106.853 67.0929 106.054 77.077 106.853 82.2687C107.651 87.4604 108.849 101.837 108.849 101.837C108.849 101.837 108.849 128.994 113.242 129.393C117.635 129.793 120.83 130.192 121.23 128.595C121.629 126.997 119.233 126.199 120.431 125.4C121.629 124.601 122.028 121.806 120.431 118.611C118.833 115.416 120.431 83.0674 120.431 83.0674L128.019 103.435C128.019 103.435 128.817 120.208 129.616 122.604C130.415 125 128.817 129.393 131.613 129.793C134.409 130.192 137.603 127.796 139.201 126.997C140.798 126.199 136.805 126.199 137.603 125.799C138.402 125.4 140.798 124.202 140 123.802C139.201 123.403 138.402 104.234 138.402 104.234C138.402 104.234 136.206 63.299 133.41 61.7015C130.615 60.1041 128.817 62.8556 128.817 62.8556L106.853 67.0929Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.04 127.796V130.991C114.04 130.991 110.446 139.676 114.04 139.676C117.635 139.676 120.43 140.576 120.43 139.377V128.595L114.04 127.796Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.603 127.79V130.985C137.603 130.985 141.197 139.67 137.603 139.67C134.009 139.67 131.213 140.57 131.213 139.372V128.589L137.603 127.79Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.036 17.3723C121.006 17.3723 124.224 14.1539 124.224 10.1838C124.224 6.21365 121.006 2.99524 117.036 2.99524C113.066 2.99524 109.847 6.21365 109.847 10.1838C109.847 14.1539 113.066 17.3723 117.036 17.3723Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.839 23.5624C114.839 23.5624 116.836 29.5528 120.031 28.3547L123.226 27.1566L128.817 65.4954C128.817 65.4954 124.424 71.8852 118.034 67.8916C111.645 63.898 114.839 23.5624 114.839 23.5624Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.43 22.3643L122.228 18.5704C122.228 18.5704 132.811 23.5624 134.408 25.1599C136.006 26.7573 136.006 29.1535 136.006 29.1535L133.21 39.1375C133.21 39.1375 134.009 61.1025 134.009 61.9012C134.009 62.6999 136.804 67.0929 134.807 65.4955C132.811 63.898 132.411 62.3006 130.814 64.6967C129.216 67.0929 125.622 69.8885 125.622 69.8885L120.43 22.3643Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.408 51.1184L133.21 62.3006C133.21 62.3006 126.022 68.6904 127.619 69.0897C129.217 69.4891 130.015 67.8916 130.015 67.8916C130.015 67.8916 132.811 70.6872 134.408 69.0897C136.006 67.4923 139.999 52.3165 139.999 52.3165L134.408 51.1184Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.189 0.0243083C115.595 -0.0326615 113.89 -0.0608424 112.546 0.797933C111.928 1.22892 111.386 1.75971 110.942 2.3686C109.633 4.02292 108.502 6.10443 108.989 8.15699L109.553 7.9368C109.553 8.48469 109.431 9.02573 109.197 9.52077C109.276 9.2896 109.542 9.66331 109.471 9.89715L108.849 11.9375C109.871 11.5627 111.143 12.3215 111.299 13.3992C111.37 11.0294 111.616 8.31193 113.538 6.92429C114.508 6.22451 115.735 6.01089 116.915 5.82119C118.004 5.64618 119.146 5.4793 120.189 5.83782C121.232 6.19634 122.12 7.26314 121.884 8.3405C122.365 8.17482 122.903 8.51001 123.14 8.95977C123.378 9.40953 123.391 9.94009 123.398 10.4487C123.91 10.8111 124.494 10.0916 124.703 9.49957C125.193 8.10993 125.629 6.63069 125.365 5.18092C125.101 3.73116 123.919 2.34568 122.446 2.34076C122.625 2.14429 122.72 1.88595 122.712 1.62038L121.497 1.51776C121.806 1.47409 122.089 1.32458 122.299 1.09483C121.812 1.63144 117.978 0.0524985 117.189 0.0243083Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.836 21.1662C116.836 21.1662 113.585 17.9803 112.415 18.1755C111.245 18.3706 109.648 21.1662 109.648 21.1662C109.648 21.1662 100.063 24.3611 100.463 27.556C100.862 30.7509 105.255 46.326 105.255 46.326C105.255 46.326 108.849 65.096 105.654 67.0929C102.459 69.0897 120.83 74.2814 121.229 71.8852C121.629 69.489 122.427 45.5273 121.229 41.933C120.031 38.3388 116.836 21.1662 116.836 21.1662Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.814 27.556H135.752C135.752 27.556 139.201 42.7318 139.6 44.3293C140 45.9267 140.798 53.5146 140.399 53.5146C140 53.5146 132.012 51.9171 132.012 53.1152L130.814 27.556Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.647 65.1362H111.742C109.897 56.6497 109.743 48.4504 111.742 40.6165H130.647C127.596 48.3095 127.405 56.4527 130.647 65.1362Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.056 54.7127L109.647 57.1089C109.647 57.1089 120.43 58.7063 120.43 54.3133C120.43 49.9203 109.647 52.3165 109.647 52.3165L106.053 51.1672L104.056 54.7127Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.255 25.1599L100.462 26.3579L96.8679 47.5242C96.8679 47.5242 95.6698 53.1152 97.6667 53.5146C99.6635 53.914 105.255 57.1089 105.255 57.1089C105.255 57.1089 106.053 51.1184 107.651 51.1184L103.657 47.9235L106.053 33.9458L105.255 25.1599Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4813 66.0548H11.2771V66.4291H37.4813V66.0548Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7642 62.6857H18.3899V66.1484H18.7642V62.6857Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1817 62.6857H29.8074V66.1484H30.1817V62.6857Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6529 10.6516H20.4487V11.026H46.6529V10.6516Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5404 10.9324H39.166V14.3951H39.5404V10.9324Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1229 10.9324H27.7485V14.3951H28.1229V10.9324Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0443 47.5247H46.8401V47.899H73.0443V47.5247Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9317 47.8054H65.5574V51.2681H65.9317V47.8054Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5142 47.8054H54.1399V51.2681H54.5142V47.8054Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4972 47.3375H2.29297V47.7118H28.4972V47.3375Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3846 47.6183H21.0103V51.081H21.3846V47.6183Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96688 47.6183H9.59253V51.081H9.96688V47.6183Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9422 28.6202H33.738V28.9945H59.9422V28.6202Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2249 25.2511H40.8506V28.7138H41.2249V25.2511Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6424 25.2511H52.2681V28.7138H52.6424V25.2511Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1203_13346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 280,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseDatePlaceholder);
export default __webpack_public_path__ + "static/media/purchaseDatePlaceholder.c94e9e4500b7a8ba65d76173ce91692e.svg";
export { ForwardRef as ReactComponent };